import script from "./RoleSectionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionForm.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionForm.vue?vue&type=style&index=0&id=510b5625&lang=css"

const __exports__ = script;

export default __exports__